var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartbeatg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 8.00016H13.0135C12.7221 7.99954 12.4386 8.09437 12.2062 8.27014C11.9739 8.44592 11.8055 8.69296 11.7268 8.9735L10.1602 14.5468C10.1501 14.5814 10.129 14.6119 10.1002 14.6335C10.0713 14.6551 10.0362 14.6668 10.0002 14.6668C9.9641 14.6668 9.92901 14.6551 9.90016 14.6335C9.87131 14.6119 9.85026 14.5814 9.84016 14.5468L6.16016 1.4535C6.15007 1.41888 6.12901 1.38847 6.10016 1.36683C6.07131 1.34519 6.03622 1.3335 6.00016 1.3335C5.9641 1.3335 5.92901 1.34519 5.90016 1.36683C5.87131 1.38847 5.85026 1.41888 5.84016 1.4535L4.2735 7.02683C4.19514 7.30627 4.02775 7.55251 3.79674 7.72817C3.56573 7.90384 3.28371 7.99933 2.9935 8.00016H1.3335",
    stroke: "#846277",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeatg);
export default __webpack_public_path__ + "static/media/heartbeatg.4ec892e4434126939ad2b6bb767c7f2d.svg";
export { ForwardRef as ReactComponent };